export const initialValues = {
  personalInformation: {
    salutation: "",
    first_name: "",
    last_name: "",
    email: "",
    telephone: "",
    company_name: "",
    tax_number: "",
    existing: false,
    consumer_id: "",
    username: "",
  },
  deliveryAddress: {
    deliv_address_street: "",
    deliv_address_house_number: "",
    deliv_address_addition: "",
    deliv_address_zipcode: "",
    deliv_address_city: "",
    differentBillingAddress: false,
    bill_address_street: "",
    bill_address_house_number: "",
    bill_address_addition: "",
    accounting_email: "",
    bill_address_zipcode: "",
    bill_address_city: "",
  },
  exchangeDetails: {
    subscription_reason: "",
    preferred_delivery_start: "",
    meterId: "",
    meteringPointId: "",
    previous_provider: "",
  },
  paymentDetails: {
    payment_method: "",
    bank_data_first_name: "",
    bank_data_last_name: "",
    bank_data_iban: "",
    authorizePayments: false,
  },
  termsAccepted: false,
  noMarketing: false,
};
